/* @sravni/react-header version 0.2.43 */
var linksMap = {};
var domainsDefault = {
    marketplace: 'https://sravni.market',
    identity: 'https://sravni.id',
    base: 'https://www.sravni.ru'
};
var showWidgetParam = 'showContentWidget=1';

export { domainsDefault, linksMap, showWidgetParam };
//# sourceMappingURL=links.js.map
